import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../styles/LunchRecommend/AddCategoryAndMenu.css';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../utils/auth';


const AddCategoryAndMenu = () => {
  const [mode, setMode] = useState(null); // 'category' or 'menu'
  const [categories, setCategories] = useState([]);

  // 공통 폼 상태
  const [categoryName, setCategoryName] = useState('');
  const [categoryNickname, setCategoryNickname] = useState('');
  const [menuName, setMenuName] = useState('');
  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const { authInfo } = useAuth();

  useEffect(() => {
    if (mode === 'menu') {
      fetchCategories();
    }
  }, [mode]);

  const fetchCategories = async () => {
    // 먼저 로그인 되어있는지 확인

    try {
      const res = await axios.get('/menu/menus');
      setCategories(res.data);
    } catch (e) {
      console.error('카테고리 불러오기 실패:', e);
    }
  };

  const handleAddCategory = async () => {
    // 먼저 로그인 되어있는지 확인
    if (!authInfo.token) {
      alert('로그인 후 이용하세요.');
    }

    try {
      await axios.post('/menu/category', {
        categoryName,
        createdBy: categoryNickname,
      });
      alert('카테고리 추가 완료!');
      setCategoryName('');
      setCategoryNickname('');
      window.location.reload();
    } catch (e) {
      console.error('카테고리 추가 실패:', e);
    }
  };

  const handleAddMenu = async () => {
    // 먼저 로그인 되어있는지 확인
    if (!authInfo.token) {
      alert('로그인 후 이용하세요.');
    }

    try {
      await axios.post('/menu/menu', {
        categoryId: selectedCategoryId,
        menuName: menuName,
      });
      alert('메뉴 추가 완료!');
      setMenuName('');
      window.location.reload();
    } catch (e) {
      console.error('메뉴 추가 실패:', e);
    }
  };

  return (
    <div className="add-wrapper">
      <h1>추가 기능</h1>

      {/* 모드 선택 */}
      <div className="mode-select">
        <button onClick={() => setMode('category')}>카테고리 추가</button>
        <button onClick={() => setMode('menu')}>메뉴 추가</button>
      </div>

      {/* 선택된 모드에 따라 다른 폼 보여주기 */}
      <AnimatePresence mode="wait">
        {mode === 'category' && (
            <motion.div
            key="category"
            className="form-block"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.4 }}
            >
            <h2>카테고리 추가</h2>
            <input
                type="text"
                placeholder="카테고리 이름"
                value={categoryName}
                onChange={e => setCategoryName(e.target.value)}
            />
            <button onClick={handleAddCategory}>카테고리 추가</button>
            </motion.div>
        )}

        {mode === 'menu' && (
            <motion.div
            key="menu"
            className="form-block"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.4 }}
            >
            <h2>메뉴 추가</h2>
            <select
                value={selectedCategoryId}
                onChange={e => setSelectedCategoryId(e.target.value)}
            >
                <option value="">카테고리 선택</option>
                {categories.map(cat => (
                <option key={cat.categoryId} value={cat.categoryId}>
                    {cat.categoryName}
                </option>
                ))}
            </select>
            <input
                type="text"
                placeholder="메뉴 이름"
                value={menuName}
                onChange={e => setMenuName(e.target.value)}
            />
            <button onClick={handleAddMenu}>메뉴 추가</button>
            </motion.div>
        )}
        </AnimatePresence>
    </div>
  );
};

export default AddCategoryAndMenu;
